import { makeStyles } from "@material-ui/core/styles"
import Color from "./Color"

export const paperStyleDefault = {
  padding: "32px",
  marginTop: "16px",
  border: `2px solid ${Color.PrimaryLight85}`,
}

export const redGreenCellColor = {
  "& .bookkeeper.negative": {
    color: "red",
  },
  "& .bookkeeper.positive": {
    color: "green",
  },
}

/**
 * Keeps Speed Dial action tooltip text in a single line
 */
export const useSpeedDialStyle = makeStyles(() => ({
  staticTooltipLabel: {
    color: Color.Black,
    maxWidth: "none",
    whiteSpace: "nowrap",
    background: Color.PrimaryLight95,
  },
}))

/**
Courier
Courier-Bold
Courier-BoldOblique
Courier-Oblique
Helvetica
Helvetica-Bold
Helvetica-BoldOblique
Helvetica-Oblique
Symbol
Times-Roman
Times-Bold
Time-Italic
Time-BoldItalic
 */
export const PDF_FONT_FAMILY_TIMES_BOLD = "Times-Bold"
export const PDF_FONT_FAMILY_COURIER_BOLD = "Courier-Bold"
export const PDF_FONT_FAMILY_DEFAULT = "Helvetica"
export const PDF_FONT_FAMILY_DEFAULT_BOLD = "Helvetica-Bold"
export const PDF_ROW_SPACE = 5
export const PDF_FONT_SIZE_H1 = 35
export const PDF_FONT_SIZE_H2 = 20
export const PDF_FONT_SIZE_H3 = 15
export const PDF_FONT_SIZE_H4 = 12
export const PDF_FONT_SIZE_DEFAULT = 10
/**
 * Higher the number, lighter the color (gray)
 * Lower the number, darker the color (black)
 */
export const PDF_TEXT_COLOR_GRAY = 90
export const PDF_TEXT_COLOR_BLACK = 40
export const PDF_TEXT_COLOR_WHITE = 100
